import { create } from "zustand";

export const useStore = create<Store>()((set) => ({
  tagsData: [],
  setTagsData: (tagsData: any[]) => set({ tagsData }),
  provinces: [],
  setProvinces: (provinces: Province[]) => set({ provinces }),
  globalPostalCode: "",
  setGlobalPostalCode: (globalPostalCode: string) => set({ globalPostalCode }),
  globalHouseNumber: "",
  setGlobalHouseNumber: (globalHouseNumber: string) => set({ globalHouseNumber }),
  globalLocation: {},
  setGlobalLocation: (globalLocation: string) => set({ globalLocation }),
  globalBirthdate: "",
  setGlobalBirthdate: (globalBirthdate: string) => set({ globalBirthdate }),
  cookiesPreferences: false,
  setCookiesPreferences: (cookiesPreferences: boolean) => set({ cookiesPreferences }),
  settings: {},
  setSettings: (settings: any) => set({ settings }),
}));

interface ProvincePageData {
  id: number;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  sitemap_exclude: boolean;
  slug: string;
  title: string;
  type: "provincie" | "provincie-nieuws" | "provincie-speerpunten";
  searchKeywords: string | null;
}

interface Province {
  id: number;
  slug: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  sitemap_exclude: boolean;
  title: string;
  name: string;
  nsc_provinciepaginas: ProvincePageData[];
}

interface Store {
  tagsData: any[];
  setTagsData: (tagsData: any[]) => void;
  provinces: Province[];
  setProvinces: (provinces: Province[]) => void;
  globalPostalCode: string;
  setGlobalPostalCode: (globalPostalCode: string) => void;
  globalHouseNumber: string;
  setGlobalHouseNumber: (globalHouseNumber: string) => void;
  globalLocation: any;
  setGlobalLocation: (globalLocation: any) => void;
  globalBirthdate: string;
  setGlobalBirthdate: (globalBirthdate: string) => void;
  cookiesPreferences: boolean;
  setCookiesPreferences: (cookiesPreferences: boolean) => void;
  settings: any;
  setSettings: (settings: any) => void;
}
